import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(3),
    width: "100%",
  },
  marginSpacing: {
    marginTop: 30,
    marginBottom: 30,
  },
  root: {
    flexGrow: 1,
  },
}));
